<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- หัวข้อ -->
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        Telepharma&nbsp; > &nbsp;ลงทะเบียนรับยา
      </h3>
      <v-row class="mx-1 my-2 mt-8">
        <v-spacer></v-spacer>
        <v-col cols="12" lg="auto" md="auto" sm="auto" class="pr-0">
          <v-btn block color="#00a99d" dark @click="openRegisterDialog()" class="card-small">
            <span class="pl-2">ลงทะเบียน (แทน)</span>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="auto" md="auto" sm="auto" class="pr-0">
          <v-btn block color="#00a99d" dark @click="ExportFile()" class="card-small">
             <v-icon color="#FFFFFF">mdi-microsoft-excel</v-icon>
            <span class="pl-2" style="text-transform: capitalize;">Export</span>
          </v-btn>
        </v-col>
      </v-row>
      
      <!-- แท็บ -->
      <v-row class="mr-1 my-2 mt-8" style="justify-content:center">
        <!-- แท็บ ทั้งหมด -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(0)"
            :class="status === 0 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
                <v-img 
                  :src="status === 0 ? require('@/assets/icon/Telepharma/all-dark.svg') : require('@/assets/icon/Telepharma/all-light.svg')"
                  class="mr-5 px-3 py-4"
                  :class="status === 0 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 0 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_all }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 0 ? 'text-ffffff' : 'text-00a99d'">ทั้งหมด</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ ลงทะเบียน -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(1)"
            :class="status === 1 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
                <v-img 
                  :src="require('@/assets/icon/Telepharma/register.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 1 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 1 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_regis }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 1 ? 'text-ffffff' : 'text-00a99d'">ลงทะเบียน</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ อยู่ระหว่างจัดส่ง -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(2)"
            :class="status === 2 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/transport.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 2 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 2 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_waiting }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 2 ? 'text-ffffff' : 'text-00a99d'">อยู่ระหว่างจัดส่ง</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ เสร็จสิ้น -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(3)"
            :class="status === 3 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/success.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 3 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 3 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_complete }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 3 ? 'text-ffffff' : 'text-00a99d'">เสร็จสิ้น</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ ยกเลิก -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(4)"
            :class="status === 4 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/cancel.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 4 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 4 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_cancel }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 4 ? 'text-ffffff' : 'text-00a99d'">ยกเลิก</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- ค้นหา -->
      <v-row class="mx-1 mb-3">
        <v-col cols="12" sm="12" md="4" lg="4" xl="4">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
                <v-text-field v-model="search" @keypress.enter="getPatientsData()" class="card-small" label="ค้นหา" hint="กรอกคำค้นหา แล้วกด Enter เพื่อค้นหา" dense solo hide-details="auto" append-icon="mdi-magnify" clearable clear-icon="mdi-close-circle"
                @click:clear="(search = ''), getPatientsData()" color="#00A99D"></v-text-field>
            </v-col>
          </v-row> 
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="card-search-start" style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
              <v-select
                hide-details
                solo
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectOrder_type"
                :items="[...status_order_type, ...itemOrder_type]"
                item-text="status_order_type"
                item-value="status_id"
                @input="getPatientsData"
                color="#00A99D"
                item-color="teal darken-2"
                class="card-small"
              >
                <template slot="append">
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="card-search-middle" style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
              <v-select
                hide-details
                solo
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectStatus_oneid"
                :items="status_oneid"
                item-text="status_oneid"
                item-value="status_id"
                @input="getPatientsData"
                color="#00A99D"
                item-color="teal darken-2"
                class="card-small"
              >
                <template slot="append">
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="card-search-end" style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2">
              <v-menu v-model="day_menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="350px" min-width="auto" bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field solo dense append-icon="mdi-calendar-multiselect" placeholder="วัน/เดือน/ปี"
                    :value="displayDate()" readonly v-bind="attrs" hide-details v-on="on" color="#00A99D" v-model="dateRangeText"
                    item-color="teal darken-2" class="card-small">
                    <template slot="append">
                      <v-btn text icon v-on="on">
                        <v-icon color="#00A99D">mdi-calendar-multiselect</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="day_select" no-title scrollable :max="dateNow" range locale="th" color="#00A99D">
                  <v-spacer></v-spacer>
                  <v-btn text color="#00A99D" @click="getPatientsData">
                    ตกลง
                  </v-btn>
                  <v-btn text color="#00A99D" @click="clearDaySelect">
                    ล้างค่า/clear
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- ตาราง -->
      <v-row class="mb-3">
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="headersTable"
            :items="itemTable"
            hide-default-footer
            :loading="loadingTable"
            loading-text="กำลังโหลดข้อมูล"
            class="px-0"
            disable-sort
          >
            <template v-slot:no-data>
              <span class="font-16">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                indeterminate
                height="3px"
                color="#00A99D"
                class="mx-0"
              ></v-progress-linear>
            </template>

             <!-- -------------------------------------- ลำดับที่ ----------------------------------- -->
            <template v-slot:[`item.No`]="{ index }">
              <div class="d-flex flex-column">
                <span class="font-14 text-text-navy-50">{{
                  index + 1 + (page - 1) * limit
                }}</span>
              </div>
            </template>

            <!-- -------------------------------------- HN ----------------------------------- -->
            <template v-slot:[`item.HN`]="{ item }">
              <div class="d-flex flex-column">
                <span class="font-14 text-text-navy-50">{{ item.cardHN || "-" }}</span>
              </div>
            </template>

            <!-- --------------------------------------ชื่อผู้ใช้บริการ----------------------------------- -->
          <template v-slot:[`item.name`]="{ item }">
            <div class="d-flex flex-column">
              <span class="font-14 text-text-navy-50">{{ item.firstname }} {{ item.lastname }}</span>
              <span class="font-10 text-text-navy-50">วันที่ลงทะเบียน: {{ showDate(item.created_at) }}</span>
            </div>
          </template>

          <!-- --------------------------------------เบอร์โทรศัพท์ติดต่อ----------------------------------- -->
          <template v-slot:[`item.contact`]="{ item }">
            <span class="font-16 text-text-navy-50">{{ mobile(item.mobile) }}</span>
          </template>

          <!-- --------------------------------------วันที่สร้างออเดอร์----------------------------------- -->
          <template v-slot:[`item.deliveryDate`]="{ item }">
            <div class="d-flex flex-column" v-if="item.createdAt">
              <span class="font-16 text-00A99D">{{
                showDate(item.createdAt)
              }}</span>
              <span class="font-16 text-text-navy-50"
                >{{ showTime(item.createdAt) }} น.</span
              >
            </div>
            <div class="d-flex flex-column" v-else>
              -
            </div>
          </template>

          <!-- -------------------------------------- บริการขนส่ง ----------------------------------- -->
          <template v-slot:[`item.order`]="{ item }">
            <span v-if="item.order_type == 'rider'" class="font-16 text-text-navy-50"
              >Rider</span
            >
            <span
              v-else-if="item.order_type == 'flash'"
              class="font-16 text-text-navy-50"
              >Flash Express</span
            >
            <span v-else class="font-16 text-text-navy-50">-</span>
          </template>

          <!-- --------------------------------------สถานะ----------------------------------- -->
          <template v-slot:[`item.status`]="{ item }">
            <div
              v-if="
                item.status == 1
              "
              class="d-flex flex-row"
            >
              <span
                class="py-1 px-3 font-12 w-400 text-296ED5"
                style="align-self:center ;background-color:#DBEEFF; border-radius: 99px;"
                v-if="item.oneid_status == 1"
              >
                ลงทะเบียน
              </span>
              <span
                class="py-1 px-3 font-12 w-400 text-296ED5"
                style="align-self:center ;background-color:#DBEEFF; border-radius: 99px;"
                v-else-if="item.oneid_status == 2"
              >
                ลงทะเบียนแทน
              </span>
            </div>
            <div v-if="item.status == 2" class="d-flex flex-row">
              <span
                class="py-1 px-3 font-12 w-400 text-FAAD14"
                style="align-self:center ;background-color:#FCF0DA; border-radius: 99px;"
              >
                อยู่ระหว่างจัดส่ง
              </span>
            </div>
            <div v-if="item.status == 3" class="d-flex flex-row">
              <span
                class="py-1 px-3 font-12 w-400 text-1AB759"
                style="align-self:center ;background-color:#F0F9EE; border-radius: 99px;"
              >
                เสร็จสิ้น
              </span>
            </div>
            <div v-if="item.status == 4" class="d-flex flex-row">
              <span
                class="py-1 px-3 font-12 w-400 text-FF6270"
                style="align-self:center ;background-color:#fbddd8e0; border-radius: 99px;"
              >
                ยกเลิก
              </span>
            </div>
          </template>

          <!-- -------------------------------------- location ----------------------------------- -->
          <template v-slot:[`item.location`]="{ item }">
            <div class="d-flex flex-column">
              <span class="font-14 text-061B2E"
                >ละติจูด: {{ item.lat || "-" }}</span
              >
              <span class="font-14 text-061B2E"
                >ลองจิจูด: {{ item.lng || "-" }}</span
              >
            </div>
          </template>

          <!-- action -->
          <template v-slot:[`item.action`]="{ item }">
            <div class="d-flex flex-row" style="justify-content:center">
              <div
                v-if="item.status == 1 && (status == 0 || status == 1)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="'order_type' in item &&
                        'lat' in item &&
                        'lng' in item &&
                        item.lat != '' &&
                        item.lng != '' && 
                        (item.order_type !== '-' || item.order_type !== '')"
                      small
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      class="py-4 px-1 mx-1 image-border"
                      style="max-width: 24px; border: 1px solid #F2F2F2"
                    >
                      <v-img
                        :src="
                          require('@/assets/icon/Telepharma/Delivery.svg')
                        "
                        @click="OpenDelivery(item)"
                      />
                    </v-btn>

                    <v-btn
                      v-else
                      small
                      outlined
                      @click="alertText('รายการนี้ยังไม่ได้บันทึกโลเคชั่น')"
                      v-bind="attrs"
                      v-on="on"
                      class="py-4 px-1 mx-1 image-border"
                      style="max-width: 24px; border: 1px solid #F2F2F2"
                    >
                      <v-img
                        :src="
                          require('@/assets/icon/Telepharma/Delivery-disable.svg')
                        "
                      />
                    </v-btn>

                  </template>
                  <span>จัดส่ง</span>
                </v-tooltip>
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      class="py-4 px-2 mx-1 image-border"
                      style="max-width: 24px; border: 1px solid #F2F2F2"
                      @click="viewPatientDetail(item)"
                    >
                      <v-img
                        :src="
                          require('@/assets/icon/Telepharma/eye-outline.svg')
                        "
                        style=" hight:12px; width:12px"
                      />
                    </v-btn>
                  </template>
                  <span>ดูรายละเอียด</span>
                </v-tooltip>
              </div>
              <div
                v-if="item.status == 1 && (status == 0 || status == 1)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      class="py-4 px-2 mx-1 image-border"
                      style="max-width: 24px; border: 1px solid #F2F2F2"
                      @click="openCancelDialog(item)"
                    >
                      <v-icon width="28" color="#E26269"
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>ยกเลิก</span>
                </v-tooltip>
              </div>
              <div v-else :style="item.status == 1 ? 'width: 50px;': ''"></div>
            </div>
          </template>

          </v-data-table>
        </v-col>
      </v-row>

      <Pagination :totals="total" :isPage="page" @page="changePage" />
      <Sweetdialog ref="sweetDialog" />
      <ExportFileDialog ref="exportFileDialog" from="patientList" />
      <cancelDialog ref="cancelDialog" from="patientList" @close="getPatientsData"/>
      <RegisterDialog ref="registerDialog" @close="getPatientsData" />

      <PatientDetailsDialog
        ref="patientDetailsDialog"
        @close="getPatientsData"
      />

    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ExportFileDialog from "../ExportFileDialog.vue"
import { Pagination } from "@/components/pagination";
import cancelDialog from "../CancelDialog.vue";
import PatientDetailsDialog from "./PatientDetailsDialog.vue";
import Sweetdialog from "../Sweetdialog.vue";
import RegisterDialog from "../PatientsList/RegisterDialog.vue"

export default {
  components: {
    ExportFileDialog,
    Pagination,
    cancelDialog,
    PatientDetailsDialog,
    Sweetdialog,
    RegisterDialog,
  },
  data() {
    return {
      summaryList: { 
        total_all: 0,
        total_regis: 0,
        total_waiting: 0,
        total_complete: 0,
        total_cancel: 0
      },
      shared_token: "",
      search: '',
      status: 0,
      page: 1,
      limit: 10,
      total: 10,
      headersTable: [
        {
          text: "ลำดับที่",
          align: "center",
          value: "No",
          width: "9%",
        },
        {
          text: "HN",
          align: "start",
          value: "HN",
          width: "10%",
        },
        {
          text: "ชื่อผู้ใช้บริการ",
          align: "start",
          value: "name",
          width: "15%",
        },
        { 
          text: "เบอร์โทรศัพท์ติดต่อ", 
          value: "contact", 
          width: "15%" 
        },
        {
          text: "วันเวลาที่สร้างออเดอร์",
          value: "deliveryDate",
          width: "16%",
        },
        { 
          text: "บริการขนส่ง", 
          value: "order", 
          width: "10%" 
        },
        { 
          text: "สถานะ", 
          value: "status", 
          width: "10%" 
        },
        { 
          text: "โลเคชั่น", 
          value: "location", 
          width: "10%" 
        },
        { 
          text: "Action", 
          value: "action", 
          width: "10%", 
          align: "center" 
        },
      ],
      itemTable: [],
      loadingTable: false,
      status_order_type: [
        { _id: "", status_order_type: "บริการขนส่งทั้งหมด", status_id: "" },
        { _id: "1", status_order_type: "Rider", status_id: "rider" },
        { _id: "2", status_order_type: "Flash Express", status_id: "flash" },
      ],
      status_oneid: [
        { _id: "", status_oneid: "สถานะการลงทะเบียนทั้งหมด", status_id: "" },
        { _id: "1", status_oneid: "ลงทะเบียน", status_id: 1 },
        { _id: "2", status_oneid: "ลงทะเบียนแทน", status_id: 2 },
      ],
      selectOrder_type: '',
      itemOrder_type: [],
      selectStatus_oneid: '',
      day_menu: false,
      dateNow: moment().format("YYYY-MM-DD"),
      day_select: [],
      start_date: "",
      end_date: "",
    };
  },
  async created() {
    this.$store.dispatch("getSharedToken");
  },
  watch: {
    async day_select() {
      if(this.day_select.length === 2) {
        await this.displayDate()
        await this.getPatientsData()
      }
    }
  },
  computed: {
    ...mapGetters({
      // permiss: "permissionsGetter" || {},
      // path: "getPath" || "",
    }),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    dateRangeText() {
      var start_year1 = ""
      var start_year2 = ""
      var end_year1 = ""
      var end_year2 = ""
      if (this.start_date === undefined && this.end_date === undefined) {
        return ""
      } else if (this.start_date != "" && this.end_date != "" && this.start_date > this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.end_date).locale("th").format("D MMMM" + end_year2)
            + " ~ "
            + moment(this.start_date).locale("th").format("D MMMM" + start_year2)
      } else if (this.start_date != "" && !this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM" + start_year2)
      } else if(this.start_date != "" && this.end_date != "" && this.start_date < this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM" + start_year2)
            + " ~ "
            + moment(this.end_date).locale("th").format("D MMMM" + end_year2)
      } else {
        return ""
      }
    },
  },
  mounted() {
    this.getPatientsData()
  },
  methods: {
    getPatientsData() {
      try {
        this.itemTable = []
        this.loadingTable = true
        this.day_menu = false;

        let start = "";
        let end = "";
        if (this.day_select !== null && this.day_select !== undefined) {
          if (this.start_date > this.end_date) {
            start = this.end_date;
            end = this.start_date;
          } else {
            start = this.start_date;
            end = this.end_date;
          }
        }

        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("status", this.status);
        params.append("keyword", this.search);
        params.append("limit", 10);
        params.append("page", this.page);
        params.append("order_type", this.selectOrder_type || "")
        params.append("start_date", start || '');
        params.append("end_date", end || '');
        params.append("check_oneid_status", this.selectStatus_oneid || '');

        this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get_regis_formdrug?${params}`).then(async (res) => {
          
          if (res.data.code == 200 && res.data.result == "success") {
            setTimeout(async () => {
              var item = res.data.data
              this.itemTable = item.data

              this.summaryList = { 
                total_all: item.pagination.total.total_all,
                total_regis: item.pagination.total.total_regis,
                total_waiting: item.pagination.total.total_waiting,
                total_complete: item.pagination.total.total_complete,
                total_cancel: item.pagination.total.total_cancel
              }

              this.total = item.pagination.total.total
              // console.log('this.total',this.total);
              if (this.total != 0) {
                await this.checkPage();
              }            
              this.loadingTable = false;
            }, 1500);
          } else {
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
            };
            setTimeout(() => {
              this.loadingTable = false;
              this.$refs.sweetDialog.open(data);
            }, 3000);
          }
        })
      } catch (error) {
        console.log("error", error);
        const data = {
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
          icon: "error",
          showConfirmButton: false,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
        };
        setTimeout(() => {
          this.loadingTable = false;
          this.$refs.sweetDialog.open(data);
        }, 3000);
      }
    },
    activeGet(index) {
      this.status = index;
      this.page = 1;
      this.getPatientsData();
    },
    changePage(page) {
      this.page = page;
      this.getPatientsData()
    },
    checkPage() {
      const t = Math.ceil(this.total / 10);
      if (t != 0 && this.page > t) {
        this.page = 1;
        this.getPatientsData();
      }
    },
    clearDaySelect() {
      this.day_select = [];
      this.start_date = "";
      this.end_date = "";
      this.day_menu = false;
      this.getPatientsData();
    },
    displayDate() {
      if (!this.day_select) return;
      return (
        (this.start_date = this.day_select[0]),
        (this.end_date = this.day_select[1])
      );
    },
    openRegisterDialog() {
      this.$refs.registerDialog.openDialog();
    },
    ExportFile() {
      this.$refs.exportFileDialog.openDialog();
    },
    openCancelDialog(item) {
      this.$refs.cancelDialog.openDialog(item);
    },
    OpenDelivery(item) {
      this.$refs.patientDetailsDialog.openDialog(item, false);
    },
    viewPatientDetail(item) {
      this.$refs.patientDetailsDialog.openDialog(item, true);
    },
    showDate(item) {
      var year1 = ""
      var year2 = ""
      year1 = moment(item).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(item).locale("th").format("D/MM/" + year2)
    },
    showTime(item) {
      return moment(item)
        .locale("TH")
        .format("LT");
    },
    mobile(mobile) {
      if (mobile == undefined) return "-";
      if (mobile.length == 10) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 10)
        );
      } else return mobile;
    },
    alertText(text) {
      this.$swal({
        type: "warning",
        icon: "warning",
        title: "<span style='color: black;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ไม่สามารถจัดส่งได้</span> ",
        html: "<span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'>" + text + "</span>",
        showCloseButton: false,
        showConfirmButton: false,
        background: "white",
        position: "center",
        timer: 5000,
        backdrop: false,
      });
    },
  }
}
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-small2 {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.theme-back-text {
  color: #ffffff;
  font-size: 18px;
  padding-left: 0px;
}

.theme-light-text {
  color: #00a99d;
  font-size: 18px;
  padding-left: 0px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}
::v-deep .v-image__image--cover {
  background-size: auto;
}
::v-deep .v-responsive {
  flex: none !important;
}
::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px !important;
  height: 48px;
}
::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .image-border.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: 38px !important;
  max-width: 38px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
  background: #ceefed !important;
}

</style>